import { colors, fonts } from 'theme'
import css from 'styled-jsx/css'

const infoProps = {
  borderColor: colors.border,
  minWidth: '255px',
  headerHeight: '70px',
  contentHeight: '650px',
  labelColor: 'rgba(22, 50, 92, 0.6)',
  valueColor: colors.secondary,
  highlightColor: colors.primary,
  pendingValuationColor: colors.primary,
  pendingShowColor: colors.terciary,
  valuationColor: colors.leatherBlack,
  showColor: colors.gray,
}

export default css`
  .info {
    border: solid 1px ${infoProps.borderColor};
    background-color: ${colors.white};
    border-left: none;
    width: ${infoProps.minWidth};
    display: flex;
    flex-direction: column;
  }
  .loading-event {
    display: flex;
    justify-content: center;
    padding-top: 2rem;
  }
  @media (max-width: 991px) {
    .info.hide {
      display: none;
    }
  }
  @media (max-width: 991px) {
    .info.event {
      width: 100%;
      border-left: solid 1px ${infoProps.borderColor};
    }
  }
  .container-phones{
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }
  .container-phones :global(.button.small.success){
    height: 1.25rem;
    font-size: 0.5rem;
  } 
  .action-switch{
    display: flex;
    justify-content: space-between;
    align-items: center;
  } 
  .info a, .info a:hover, .info a:active, .info a:visited {
    color: ${infoProps.highlightColor};
    text-decoration: none;
  }
  header.header {
    height: ${infoProps.headerHeight};
    display: flex;
    justify-content: start;
    flex-direction: column;
    border-bottom: solid 1px ${infoProps.borderColor};
    padding: 15px 20px;
    position: relative;
  }
  footer.footer {
    border-top: solid 1px ${infoProps.borderColor};
    flex-grow: 3;
  }
  .content {
    padding: 15px 20px;
    overflow: auto;
    flex-grow: 1;
    flex-shrink: 1;
  }
  .header p {
    margin: 3px;
  }
  .label {
    font: ${fonts.medium};
    font-size: 12px;
    color: ${infoProps.labelColor};
  }
  .value {
    font: ${fonts.medium};
    font-size: 14px;
    color: ${infoProps.valueColor};
  }
  
  .highlight {
    color: ${infoProps.highlightColor}
  }
  h4.header {
    font: ${fonts.bold};
    font-size: 16px;
  }
`

export const eventTypes = css`
  .list {
    list-style: none;
    padding-left: 30px;
  }
  .list p {
    margin: 0;
  }
  .list li {
    padding-bottom: 20px;
  }
  .list li > p {
    position: relative;
  }
  .list li > p:first-child::before {
    display: inline-block;
    width: 15px;
    border: solid 3px ${infoProps.pendingShowColor};
    border-radius: 50%;
    height: 15px;
    position: absolute;
    top: 0;
    left: -30px;
    content: '';
  }
  .list li.pending.broker-valuation > p:first-child::before {
    border-color: ${colors.danger}
  }
  .list li.confirmed.broker-valuation > p:first-child::before {
    border-color: ${colors.text}
  }
  .list li.confirmed.custom-event > p:first-child::before {
    border-color: ${colors.badge}
  }
  .list li.pending.valuation > p:first-child::before {
    border-color: ${infoProps.pendingValuationColor}
  }
  .list li.valuation > p:first-child::before {
    border-color: ${infoProps.valuationColor}
  }
  .list li.pending.show > p:first-child::before {
    border-color: ${infoProps.pendingShowColor}
  }
  .list li.show > p:first-child::before {
    border-color: ${infoProps.showColor}
  }
`

export const closeButton = css`
  .close-button {
    position: absolute;
    top: 5px;
    cursor: pointer;
    right: 10px;    
  }
`

export const actions = css`
  .container {
    display: flex;
    justify-content: center;
    align-items: start;
    height: 100%;
    padding: 1rem 0;
  }
  .container :global(> .action-btn) {
    margin-right: 5px;
  }
  .container > :global(.action-btn:last-child) {
    margin-right: 0;
  }
`

export const appointmentStatus = css`
  .appointment{
    margin: 5px 0;
  }
`
